import { CheckOutlined, CloseOutlined, EyeOutlined, MoreOutlined } from "@ant-design/icons";
import { Button, ConfigProvider, Dropdown, Flex, Form, Modal, Row, Space } from "antd";
import ModalMyRequest from "components/elements/Modal/ModalMyRequest";
import TableAntd from "components/elements/Table/Table";
import StatusTag from "components/elements/TagCustom/StatusTag";
import dayjs from "dayjs";
import { REQUEST_APPROVE_TAB } from "features/requestApproval/schemas/RequestApproveTab";
import moment from "moment";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { formatDateTime } from "utils/formatter";

const PendingApprovalLeaveTable = ({
  isLoading = false,
  pagination = {},
  dataSource = [],
  onReturn = () => { },
  onApprove = () => { },
  onApproveAll = () => { },
  onRejectAll = () => { },
  onReject = () => { },
  onCancel = () => { },
  onChange = () => { },
  onOpenModal = () => { },
  modalProps = {},
  modalFlag = true,
  modalOpen,
  pageType = ""
}) => {
  const { t, i18n } = useTranslation();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const hasSelected = selectedRowKeys.length > 0;

  function formatDate(dateString) {
    if (!dateString) return;
    const date = dayjs(dateString);
    if (i18n.language === "en") {
      return date.format("DD/MM/YYYY");
    } else {
      return `${date.format(`DD/MM/${date.year() + 543}`)}`;
    }
  }

  const columns = [
    {
      title: <div className="text-table">{t('workin_location.label.reqid')}</div>,
      dataIndex: "sequence",
      key: "sequence",
      visible: true,
      align: "center",
    },
    {
      title: <div className="text-table">{t('translation.employee.employee')}</div>,
      dataIndex: "employee",
      key: "employee",
      visible: true,
      align: "center",
      render: (text, record) => {
        return i18n.language === 'en' ? <span>{record?.employee?.nameAndSurnameEn}</span> : <span>{record?.employee?.nameAndSurname}</span>
      }
    },
    {
      title: <div className="text-table">{t('leave_type_type')}</div>,
      dataIndex: "requestType",
      key: "requestType",
      visible: true,
      align: "center",
      render: (text, record) => {
        return i18n.language === 'en' ? <span>{record?.leaveType?.leaveTypeNameEn}</span> : <span>{record?.leaveType?.leaveTypeName}</span>
      }
    },
    {
      title: <div className="text-table">{t("leave_type.label.create_date")}</div>,
      dataIndex: "createDate",
      key: "createDate",
      visible: true,
      align: "center",
      render: (_, record) => {
        return record?.createDate ? formatDate(moment(record?.createDate)) : "-"
      },
    },
    {
      title: <div className="text-table">{t('start-date')}</div>,
      dataIndex: "leaveDate",
      key: "leaveDate",
      visible: true,
      align: "center",
      render: (_, record) => {
        return record?.leaveDate ? formatDate(record?.leaveDate) : "-"
      },
    },
    {
      title: <div className="text-table">{t('end-date')}</div>,
      dataIndex: "endDate",
      key: "endDate",
      visible: true,
      align: "center",
      render: (_, record) => {
        return record?.endDate ? formatDate(record?.endDate) : "-"
      },
    },
    {
      title: <div className="text-table" >{t("leave_type.label.start-time")}</div>,
      dataIndex: "leaveDateTimeString",
      key: "leaveDateTimeString",
      visible: true,
      align: "center"
    },
    {
      title: <div className="text-table">{t("leave_type.label.end-time")}</div>,
      dataIndex: "endDateTimeString",
      key: "endDateTimeString",
      visible: true,
      align: "center"
    },
    {
      title: <div className="text-table">{t('leave_type.label.duration')}</div>,
      dataIndex: "totalDuration",
      key: "totalDuration",
      visible: true,
      align: "center",
      render: (_, record) => {
        if (record.durationType === 'ALLDAY') {
          return i18n.language === 'en' ? record?.totalDuration + " Day" : record?.totalDuration + " วัน"
        } else {
          return i18n.language === 'en' ? record?.totalDurationHour + "H " + record?.totalDurationMinute + "M" : record?.totalDurationHour + " ชม. " + record?.totalDurationMinute + " นาที"
        }
      }
    },
    {
      title: <div className="text-table">{t('leave_type_description')}</div>,
      dataIndex: "description",
      key: "description",
      visible: true,
      align: "center",
    },
    {
      title: <div className="text-table">{t('leave_type_status')}</div>,
      dataIndex: "approveStatus",
      key: "approveStatus",
      align: "center",
      visible: true,
      render: (text, record) => {
        let language = i18n.language == "en" ? "En" : ""
        return <StatusTag value={(record?.["approveStatus" + language])} />
      },
    },
    {
      title: <div className="text-table">{t('วันที่อนุมัติ')}</div>,
      dataIndex: "approverDate",
      key: "approverDate",
      align: "center",
      visible: !modalFlag,
      render: (_, record) => {
        return record?.approverDate ? formatDateTime(record?.approverDate) : "-"
      }
    },
    {
      title: "",
      key: "action",
      fixed: "right",
      align: "center",
      visible: modalFlag,
      width: "50px",
      render: (_, record) => (
        <Space size="middle">
          <Dropdown
            menu={{
              items: [
                {
                  key: "2",
                  onClick: () => { onOpenModal(record); },
                  label: `${t("action.view")}`,
                  icon: (
                    <EyeOutlined
                      style={{ fontSize: "18px", color: "gray" }}
                    />
                  ),
                },
                {
                  key: "3",
                  onClick: () => onApprove({
                    ...record,
                    table: REQUEST_APPROVE_TAB.LEAVE
                  }),
                  label: `${t("action.approve")}`,
                  icon: (
                    <CheckOutlined
                      style={{ fontSize: "18px", color: "gray" }}
                    />
                  ),
                },
                {
                  key: "4",
                  onClick: () => onReject({
                    ...record,
                    table: REQUEST_APPROVE_TAB.LEAVE
                  }),
                  label: `${t("action.reject")}`,
                  icon: (
                    <CloseOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
              ],
            }}
          >
            <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
          </Dropdown>
        </Space>
      ),
    },
  ];

  const visibleColumns = columns.filter((col) => col.visible);

  const processedDataSource = dataSource.map(item => {
    if (Array.isArray(item.children) && item.children.length === 0) {
      return { ...item, children: null };
    }
    return item;
  });

  const onSelectChange = newSelectedRowKeys => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  return (
    <Flex vertical gap={16}>
      <ConfigProvider
        theme={{
          components: {
            Table: {
              selectionColumnWidth: "45px"
            },
          },
        }}
      >
        <TableAntd
          loading={isLoading}
          style={{ backgroundColor: "white", width: "100%" }}
          pagination={{
            ...pagination,
            showTotal: (total, range) =>
              t("paginate.description")
                .replace("{min}", range[0])
                .replace("{max}", range[1])
                .replace("{total}", total),
          }}
          dataSource={processedDataSource}
          rowKey={(record) => record.id}
          columns={visibleColumns}
          onChange={onChange}
          scroll={{ x: true }}
          rowSelection={pageType === "view" ? rowSelection : undefined}
        />
      </ConfigProvider>

      {hasSelected && pageType === "view" &&
        (<Flex vertical gap={8} style={{ alignItems: "end" }}>
          <span>{`${t("common.selected")} ${selectedRowKeys.length} ${t("common.items")}`}</span>
          <Row style={{ gap: "8px" }}>
            <Button
              type="default"
              style={{ borderRadius: "8px", height: "40px" }}
              onClick={() => {
                const selectedRecords = dataSource.filter(item => selectedRowKeys.includes(item.id));
                onRejectAll(selectedRecords).then(() => {
                  setSelectedRowKeys([]);
                });
              }}
            >
              {t("request_approval.label.not_approved")}</Button>
            <Button
              type="primary"
              style={{ borderRadius: "8px", height: "40px", backgroundColor: "var(--button-color" }}
              onClick={() => {
                const selectedRecords = dataSource.filter(item => selectedRowKeys.includes(item.id));
                onApproveAll(selectedRecords).then(() => {
                  setSelectedRowKeys([]);
                });
              }}
            >{t("request_approval.label.approve")}</Button>
          </Row>
        </Flex>)}
    </Flex >
  );
};

export default PendingApprovalLeaveTable;
